import 'iframe-resizer';


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/main.vendors.js